import { disableBodyScroll, enableBodyScroll } from '~/js/utilities/dom';

const heroProductGalleryModal = () => ({
  currentSlideInfo: '',

  init() {
    this.currentSlideInfo = `1/${this.medias.length}`;

    this.mutationObserver = new MutationObserver(
      this.handleMutation.bind(this)
    );
    this.mutationObserver.observe(this.$el, {
      attributes: true,
      attributeFilter: ['open'],
    });
  },

  destroy() {
    this.mutationObserver.disconnect();
  },

  handleMutation() {
    const { open: newOpen } = this.$el;

    if (newOpen) {
      disableBodyScroll();
    } else {
      enableBodyScroll();
    }
  },
});

export default heroProductGalleryModal;
